import { render, staticRenderFns } from "./MenuTabLogic.vue?vue&type=template&id=1bec2bc0&scoped=true"
import script from "./MenuTabLogic.vue?vue&type=script&lang=js"
export * from "./MenuTabLogic.vue?vue&type=script&lang=js"
import style0 from "./MenuTabLogic.vue?vue&type=style&index=0&id=1bec2bc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bec2bc0",
  null
  
)

export default component.exports